// import WebSocket, { WebSocketServer } from 'ws';
//
// const wss = new WebSocketServer({ port: 8080 });
//
//
// wss.on('connection', (socket) => {
//   console.log(`Client connected with IP address ${socket._socket.remoteAddress}`);
// })

import { getCookie, setCookie } from '../utils/cookie.js'

async function fetchIpAddress() {
	const response = await fetch('https://api.ipify.org?format=json')
	const data = await response.json()
	return data.ip
}

async function getGeolocation() {
	const ip = await fetchIpAddress()
	const response = await fetch(`/api/address/get-location-by-ip?ip=${ip}`)
	const data = await response.json()

	if (data.status === 1) return data.full
	return false
}

async function saveGeolocation() {
	if (!getCookie('geolocation')) {
		const geolocation = await getGeolocation()
		// setCookie('geolocation', geolocation, 0.04, '')
		document.cookie = `geolocation=${geolocation};path=/`
		window.geolocationInfo = geolocation
	} else {
		const geolocation = getCookie('geolocation')
		if (!window.geolocationInfo) {
			window.geolocationInfo = geolocation
		}
	}
}

export { saveGeolocation }
